module.exports = __webpack_public_path__ + "img/carryingValueGreen.a925f269.png";